import React, { Component } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { GetSystem, EditSystem } from './SystemsAction';
import { Container, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog, Grid, Button, TextField } from '@material-ui/core';
import OverLoader from '../../components/common/loader';
import '../../App.css';
import './system.css'
import isEmpty from 'lodash.isempty';
import { LogoutAction } from '../../actions';
import { Prompt } from "react-router-dom";

class System extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hoursperdayField: '',
      tolerancePlaningField: '',
      toleranceRegisteringField: '',
      vatrateField: '',
      systemId: '',
      selectedFile: null,
      isDeleteContactDialogOpen: false,
      error: [],
      isBlocking: false,
      accessErrorDialog: false,
      fileName: ''
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')

    if (Number(access_rights.system_settings) === 2 && token !== null)
      this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { GetSystem } = this.props
    GetSystem()
  }
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { system_settings, error_validation, access_error, dataDeclerationPdf } = this.props
    if (nextProps.system_settings !== system_settings) {
      let planing = nextProps.system_settings.toleranceplaning
      let registering = nextProps.system_settings.toleranceregistering
      let vat = nextProps.system_settings.vatrate !== null ? nextProps.system_settings.vatrate.toString().replace(".", ",") : nextProps.system_settings.vatrate
      let hours = nextProps.system_settings.hoursperday !== null ? nextProps.system_settings.hoursperday.toString().replace(".", ",") : nextProps.system_settings.hoursperday
      this.setState({
        tolerancePlaningField: planing,
        toleranceRegisteringField: registering,
        vatrateField: vat,
        hoursperdayField: hours,
        systemId: nextProps.system_settings.id,
        fileName: nextProps.system_settings.pdf_file_name,
        isBlocking: false,
      })
    }
    if (nextProps.error_validation !== error_validation) {
      this.setState({ error: nextProps.error_validation })
    }
    if (nextProps.access_error !== access_error) {
      this.setState({ accessErrorDialog: true })
    }
  }

  onChangeHandler = event => {
    this.setState({
      selectedFile: event.target.files[0],
      fileName: event.target.files[0].name,
      isBlocking: true,
      loaded: 0,
    })
  }
  editSystemSettings = () => {
    const { systemId, selectedFile, hoursperdayField, tolerancePlaningField, vatrateField, toleranceRegisteringField } = this.state;
    const { EditSystem } = this.props;
    EditSystem(systemId, toleranceRegisteringField, tolerancePlaningField, hoursperdayField, vatrateField, selectedFile);
  }

  resetForm = () => {
    const { system_settings } = this.props
    this.setState({
      hoursperdayField: Number(system_settings.hoursperday),
      tolerancePlaningField: system_settings.toleranceplaning,
      toleranceRegisteringField: system_settings.toleranceregistering,
      vatrateField: Number(system_settings.vatrate),
      isDeleteContactDialogOpen: false,
      isBlocking: false,
      error: []
    });
    setTimeout(() => {
      this.focusTextInput()
    }, 200)
  }

  render() {
    const { fileName, error, isBlocking, accessErrorDialog, isDeleteContactDialogOpen, hoursperdayField, tolerancePlaningField, toleranceRegisteringField, vatrateField } = this.state
    const { isloading, access_error, dataDeclerationPdf } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="md">
          <Grid container spacing={3} className="mainBlock">
            {isEmpty(error.message) ?
              <Grid item md={12} sm={12} xs={12}
                className={`${Number(access_rights.system_settings) === 1 ? "disableALlFields" : ""}`}
              >
                <Prompt
                  when={isBlocking}
                  message={location =>
                    `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                  }
                />
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <div className="inner-field">
                    <label className="mb0">Anzahl Stunden pro Standard-Tag</label>
                    <div className="input-span">
                      <NumberFormat
                        customInput={TextField}
                        className="innerInput rightToLeft"
                        required={true}
                        inputRef={this.textInput}
                        inputProps={{
                          maxLength: 40
                        }}
                        variant="outlined"
                        helperText={!isEmpty(error.hoursperday) ? error.hoursperday : ''} error={!isEmpty(error.hoursperday) ? true : false}
                        value={hoursperdayField}
                        thousandSeparator='.'
                        decimalSeparator=","
                        decimalScale="2"
                        allowNegative={false}
                        onChange={(e) => {
                          this.setState({ hoursperdayField: e.target.value, isBlocking: true, registeringFieldsError: false })
                          if (!isEmpty(error.hoursperday))
                            error.hoursperday = []
                        }} />
                      <span>Stunden</span>
                    </div>
                  </div>
                  <div className="inner-field">
                    <label className="mb0">Planung nach X Tagen im vergangenen Monat (Standard)</label>
                    <div className="input-span">
                      <NumberFormat
                        customInput={TextField}
                        className="innerInput rightToLeft"
                        required={true}
                        inputProps={{
                          maxLength: 40
                        }}
                        variant="outlined"
                        helperText={!isEmpty(error.toleranceplaning) ? error.toleranceplaning : ''} error={!isEmpty(error.toleranceplaning) ? true : false}
                        value={tolerancePlaningField}
                        thousandSeparator='.'
                        decimalSeparator=","
                        decimalScale={false}
                        onChange={(e) => {
                          if (!isEmpty(error.toleranceplaning))
                            error.toleranceplaning = []
                          this.setState({ tolerancePlaningField: e.target.value, isBlocking: true, planFiledError: false })
                        }} />

                      <span>Tage</span>
                    </div>
                  </div>
                  <div className="inner-field">
                    <label className="mb0">Stundenerfassung Buchung nach X Tagen im vergangenen Monat (Standard)</label>
                    <div className="input-span">
                      <NumberFormat
                        inputProps={{
                          maxLength: 40
                        }}
                        customInput={TextField}
                        className="innerInput rightToLeft"
                        required={true}
                        variant="outlined"
                        helperText={!isEmpty(error.toleranceregistering) ? error.toleranceregistering : ''} error={!isEmpty(error.toleranceregistering) ? true : false}
                        value={toleranceRegisteringField}
                        thousandSeparator='.'
                        decimalSeparator=","
                        decimalScale={false}
                        allowNegative={false}
                        onChange={(e) => {
                          if (!isEmpty(error.toleranceregistering))
                            error.toleranceregistering = []
                          this.setState({ toleranceRegisteringField: e.target.value, isBlocking: true, registeringFieldsError: false })
                        }} />
                      <span>Tage</span>
                    </div>
                  </div>
                  <div className="inner-field">
                    <label className="mb0">Mehrwertsteuersatz</label>
                    <div className="input-span">
                      <NumberFormat
                        customInput={TextField}
                        className="innerInput rightToLeft"
                        required={true}
                        inputProps={{
                          maxLength: 40
                        }}
                        variant="outlined"
                        helperText={!isEmpty(error.vatrate) ? error.vatrate : ''} error={!isEmpty(error.vatrate) ? true : false}
                        value={vatrateField}
                        thousandSeparator='.'
                        decimalSeparator=","
                        decimalScale="2"
                        allowNegative={false}
                        onChange={(e) => {
                          this.setState({ vatrateField: e.target.value, isBlocking: true, vatrateFieldsError: false })
                          if (!isEmpty(error.vatrate))
                            error.vatrate = []
                        }} />
                      <span>%</span>
                    </div>
                  </div>
                  <div className="inner-field upload-field">
                    <label id='val'>Sicherheitsrichtlinie
                     {!isEmpty(dataDeclerationPdf) &&
                        <Button variant="outlined" color="primary"
                          className="m-10"
                          onClick={() => {
                            const theLink = document.createElement('a');
                            theLink.href = dataDeclerationPdf;
                            theLink.download = `${fileName}`;
                            document.body.appendChild(theLink);
                            theLink.click();
                            document.body.removeChild(theLink);
                          }
                          }
                        >PDF download </Button>
                      }
                    </label>
                    <input type="file" id="files" name="file" accept="application/pdf" onChange={this.onChangeHandler} />
                    {Number(access_rights.system_settings) === 2 &&
                      <Button variant="outlined" color="primary"> <label htmlFor="files" style={{ cursor: 'pointer' }}>Datei auswählen</label></Button>
                    }
                    <div>

                    </div>
                  </div>
                  {Number(access_rights.system_settings) !== 1 &&
                    <div className="actionBtn ma0">
                      <Button variant="outlined" color="primary" className="m-10" onClick={() => { this.editSystemSettings() }} >Speichern</Button>
                      <Button variant="outlined" color="secondary" className="m-10" onClick={() => this.setState({ isDeleteContactDialogOpen: true })} >Abbrechen</Button>
                    </div>
                  }
                  <Dialog
                    open={isDeleteContactDialogOpen}
                  >
                    <DialogTitle>Systemeinstellungen</DialogTitle>
                    <DialogContent>
                      <DialogContentText >
                        Möchten Sie zuvor gespeicherte Werte wiederherstellen?
              </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.resetForm} size="small" variant="outlined" color="primary">
                        Bestätigen
              </Button>
                      <Button onClick={() => this.setState({ isDeleteContactDialogOpen: false })} size="small" variant="outlined" color="secondary" >
                        Abbrechen
              </Button>
                    </DialogActions>
                  </Dialog>

                  <Dialog
                    open={accessErrorDialog}
                  >
                    <DialogTitle>Systemeinstellungen</DialogTitle>
                    <DialogContent>
                      <DialogContentText >
                        {access_error && access_error.message}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => this.setState({ accessErrorDialog: false })} size="small" variant="outlined" color="secondary" >
                        Abbrechen
              </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </Grid>
              :
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <h3>{error.message}</h3>
                </div>
              </Grid>
            }
          </Grid>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = ({ systems }) => {
  return {
    isloading: systems.loading,
    system_settings: systems.system_settings,
    dataDeclerationPdf: systems.dataDeclerationPdf,
    error_validation: systems.error_message,
    access_error: systems.access_error,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetSystem: () => dispatch(GetSystem()),
    LogoutAction: () => dispatch(LogoutAction()),
    EditSystem: (id, hoursperday, plaining, registering, vatrate, selectedFile) => dispatch(EditSystem(id, hoursperday, plaining, registering, vatrate, selectedFile)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(System)